import { render, staticRenderFns } from "./ShopGiveConfig.vue?vue&type=template&id=4b3cf7f5&scoped=true&"
import script from "./ShopGiveConfig.vue?vue&type=script&lang=js&"
export * from "./ShopGiveConfig.vue?vue&type=script&lang=js&"
import style0 from "./ShopGiveConfig.vue?vue&type=style&index=0&id=4b3cf7f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3cf7f5",
  null
  
)

export default component.exports